module.exports = __webpack_public_path__ + "img/NP.475ebcec.svg";